<div class="flex flex-col gap-4 p-4">
  <h1 class="text-2xl leading-snug">Versand</h1>
  <div class="flex flex-col gap-4">
    <p>Wählen Sie, wie Sie Ihre Marken und Zutrittsbänder erhalten möchten.</p>
    <div class="flex flex-col gap-2">
      @for (deliveryOption of deliveryOptions; track deliveryOption.id) {
        <button (click)="selectShipping(deliveryOption)"
             class="text-left bg-white rounded-xl p-4 grid grid-cols-[15px,1fr] gap-2 border-2 border-benzGrey-900 hover:border-benzGrey-400">
          <span class="pt-[8px] scale-125">
            @if (progressService.selectedShipping() && progressService.selectedShipping()?.id === deliveryOption.id) {
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 0.5C10.5829 0.5 13.5 3.41714 13.5 7C13.5 10.5829 10.5829 13.5 7 13.5C3.41714 13.5 0.5 10.5829 0.5 7C0.5 3.41714 3.41714 0.5 7 0.5ZM7 1.5C3.96686 1.5 1.5 3.96686 1.5 7C1.5 10.0331 3.96686 12.5 7 12.5C10.0331 12.5 12.5 10.0331 12.5 7C12.5 3.96686 10.0331 1.5 7 1.5ZM7 4.5C8.35086 4.5 9.5 5.64914 9.5 7C9.5 8.35086 8.35086 9.5 7 9.5C5.64914 9.5 4.5 8.35086 4.5 7C4.5 5.64914 5.64914 4.5 7 4.5Z"
                  fill="#B02B2C" stroke="#B02B2C" />
              </svg>
            } @else {
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 0.5C10.5829 0.5 13.5 3.41714 13.5 7C13.5 10.5829 10.5829 13.5 7 13.5C3.41619 13.5 0.5 10.5829 0.5 7C0.5 3.4171 3.41619 0.5 7 0.5ZM7 1.5C3.96686 1.5 1.5 3.96686 1.5 7C1.5 10.0331 3.96686 12.5 7 12.5C10.0331 12.5 12.5 10.0331 12.5 7C12.5 3.96686 10.0331 1.5 7 1.5Z"
                  fill="#48433E" stroke="#48433E" />
              </svg>
          }
          </span>
          <div class="flex-col flex">
            <p>{{ deliveryOption.name }}</p>
            <span>+ {{ deliveryOption.price | currency:'EUR' }}</span>
          </div>
        </button>
      }
    </div>
    @if (progressService.selectedShipping()) {
      <button routerLink="/booking/summary" class="px-8 py-4 bg-benzRed-700 text-white rounded-lg">{{ progressService.selectedShipping()?.buttonText }} bestätigen
      </button>
    }
  </div>
</div>
